// Service Center/Monitoring API
import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    ContainerAvailabilityAllowedProductTypes,
} from 'app/enums/label.enums'

type ServiceCenterMonitoringRequests = {
    domainName: string,
    getAvailability: RequestConfigFunction<{
        params: {
            serviceCenter: {id: number},
            productType: ContainerAvailabilityAllowedProductTypes,
        }
    }>,
    getRequiredContainersAvailability: RequestConfigFunction<{ data: Record<string, any> }>,
    getDryStorage: RequestConfigFunction<{ params: { serviceCenter: {id: number}, } }>,
    getTruckCapacity: RequestConfigFunction<{ params: { serviceCenter: {id: number}} }>,
    scenarioEditorInitialValues: RequestConfigFunction<{params?: Record<string, any>}>,
    scenarioEditorContainerAvailability: RequestConfigFunction<{params?: Record<string, any>}>,
    getProductMetrics: RequestConfigFunction<{serviceCenterId: number}>,
}

const serviceCenterMonitoringRequests: ServiceCenterMonitoringRequests = {
    domainName: 'ServiceCenterMonitoring',
    getAvailability: ({
        params,
    }) => {
        return {
            url: 'servicecenter/monitoring/container-availability',
            method: 'POST',
            data: params,
        }
    },
    getRequiredContainersAvailability: ({
        data,
    }) => {
        return {
            url: 'servicecenter/monitoring/container-availability/required-containers',
            method: 'POST',
            data,
        }
    },
    getDryStorage: ({
        params,
    }) => {
        return {
            url: 'servicecenter/monitoring/dry-storage',
            method: 'POST',
            data: params,
        }
    },
    getTruckCapacity: ({
        params,
    }) => {
        return {
            url: 'servicecenter/monitoring/truck-capacity',
            method: 'POST',
            data: params,
        }
    },
    scenarioEditorInitialValues: (params = {}) => {
        return {
            url: 'servicecenter/monitoring/container-availability/scenario-editor/initial-values',
            method: 'POST',
            ...params,
        }
    },
    scenarioEditorContainerAvailability: (params) => {
        return {
            url: 'servicecenter/monitoring/container-availability/scenario-editor',
            method: 'POST',
            data: params,
        }
    },
    getProductMetrics: ({
        serviceCenterId,
    }) => {
        return {
            url: `servicecenter/${serviceCenterId}/productmetrics`,
            method: 'GET',
        }
    },
}

export default serviceCenterMonitoringRequests
